import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import UserService from '../services/UserService';

class Logout extends Component {
  render() {
    const { className = "", t } = this.props;

    return (
      <button
        className={className}
        onClick={ () => UserService.doLogout()}
      >
        {t('common.logout')}
      </button>
    );
  }
}
export default withTranslation()(Logout);